import PanelItem from './PanelItem'

const TextPanelItem = (props) => (
    <PanelItem {...props}>
        {props.value}
    </PanelItem>
)

export default TextPanelItem;